import styled from 'styled-components';

export const StyledProductImage = styled.img`
  display: flex;
  width: 60%;
  border-radius: ${({ theme: { spacing } }) => spacing(3)};
  overflow: hidden;
`;
